<template>
  <b-nav-item-dropdown
    right
    class="mt-1 notification-dd"
    @show="isOpen = true"
    @hide="isOpen = false"
  >
    <template #button-content>
      <b-icon-bell style="width: 22px; height: 22px"></b-icon-bell>
      <span style="position: relative">
        <b-badge
          v-if="notiCount"
          pill
          variant="primary"
          style="position: absolute; top: 0; left: 0"
          >{{ notiCount > 99 ? "99+" : notiCount }}</b-badge
        >
      </span>
    </template>
    <b-dropdown-text>
      <b-tabs fill lazy>
        <b-tab title="My" v-if="loggedIn">
          <div class="tab-content">
            <order-notification-list
              :isOpen="isOpen"
              @data-loaded="getNotiCount"
            ></order-notification-list>
          </div>
        </b-tab>
        <b-tab title="Public">
          <div class="tab-content">
            <public-notification-list
              :isOpen="isOpen"
              @data-loaded="notiCount = 0"
            ></public-notification-list>
          </div>
        </b-tab>
      </b-tabs>
    </b-dropdown-text>
  </b-nav-item-dropdown>
</template>

<script>
import {
  VBToggle,
  BNavItemDropdown,
  BDropdownText,
  BBadge,
  BIconBell,
  BTabs,
  BTab,
} from "bootstrap-vue";
import { onMessage } from "@firebase/messaging";
import messaging from "../../firebase";
import notificationService from "../../services/notification.service";

export default {
  components: {
    BNavItemDropdown,
    BDropdownText,
    BBadge,
    BIconBell,
    BTabs,
    BTab,
    OrderNotificationList: () => import("./OrderNotificationList.vue"),
    PublicNotificationList: () => import("./PublicNotificationList.vue"),
  },
  directives: {
    "b-toggle": VBToggle,
  },
  data: () => ({
    notiCount: 0,
    isOpen: false,
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    this.listenForegroundMessage();
    if (this.loggedIn) this.getNotiCount();
  },
  methods: {
    async getNotiCount() {
      try {
        let res = await notificationService.getNewNotificationCount();
        this.notiCount = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async listenForegroundMessage() {
      let reg = await navigator.serviceWorker.getRegistration();

      onMessage(messaging, (payload) => {
        console.log("Message received. ", payload);

        let { notification, data } = payload;
        let notificationTitle = "Test title";
        let notificationBody = "Test body";

        if (notification && notification.title && notification.body) {
          notificationTitle = notification.title;
          notificationBody = notification.body;
        } else if (data && data.title && data.body) {
          notificationTitle = data.title;
          notificationBody = data.body;
        }

        const notificationOptions = {
          body: notificationBody,
        };
        if (reg) reg.showNotification(notificationTitle, notificationOptions);
      });

      // listen message event from SW
      navigator.serviceWorker.addEventListener("message", (event) => {
        let { data } = event;

        if (
          data &&
          data.code == "onPushMessageReceived" &&
          data.count != null
        ) {
          if (data.publicNoti != null && data.publicNoti == true) {
            // update noti count
            if (this.loggedIn) this.getNotiCount();
            else {
              // guest noti count increase (temp)
              this.notiCount += 1;
            }
          } else {
            this.notiCount = +data.count;
          }
        }
      });
    },
  },
};
</script>

<style >
li.notification-dd ul.dropdown-menu {
  display: inline-flexbox;
  width: 320px;
  padding-top: 0;
  padding-bottom: 0;
}
li.notification-dd ul.dropdown-menu .tab-content {
  overflow-y: auto;
  height: 360px;
}

li.notification-dd ul.dropdown-menu .b-dropdown-text {
  padding: 0;
}

li.notification-dd ul.dropdown-menu button {
  width: 100%;
  white-space: normal;
}
</style>
